export default{
    products: {},
    selected:{},
    on_coverage : [],
    loading: false,
    error: "",
    logos: [],
    information: []
}